// @core/api/endpoints/chat/list_conversation_members.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListConversationMembersResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List conversation members
 * Returns a paginated list of all members in the conversation, including their roles and online status.
 */
export async function ListConversationMembers(
  conversation_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListConversationMembersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/members`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.get<ListConversationMembersResponse>(requestPath, { ...requestOptions, params });
}
